module.exports = __webpack_public_path__ + "static/media/dreamweaver.bd44a953.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/dreamweaver.png
// module id = 2550
// module chunks = 0